// extracted by mini-css-extract-plugin
export var skipButton = "skipButton-module--skipButton--4b8d1";